import { useRouter } from 'next/router';
import ru from '../locales/ru.json';
import en from '../locales/en.json';
import cn from '../locales/cn.json';
import {useEffect} from "react";
import {getCookie, setCookie} from "cookies-next";

const useLocalization = () => {
    const router = useRouter();

    useEffect(() => {
        if (router.locale !== getCookie('lang')) {
            setCookie('lang', router.locale);
        }
    }, [router])

    const json2object = (json: any) => JSON.parse(JSON.stringify(json));

    switch (router.locale) {
        case 'ru':
            return json2object(ru);
        case 'en':
            return json2object(en);
        case 'cn':
            return json2object(cn);
        default:
            return json2object(ru);
    }
};

export default useLocalization;
